/* ==========================================================================
   fx-header.js — Fox-Rings transparent-over-hero header
   Adds .fx-header-solid to <body> once the visitor scrolls past the hero.
   ========================================================================== */
(function () {
  'use strict';

  if (!document.body.classList.contains('fx-header-overlay')) return;

  var header = document.querySelector('.shopify-section-header, .section-header');
  var threshold = 60;

  function measure() {
    var hero = document.querySelector('.fx-slides-section, .fx-slides');
    if (hero) {
      threshold = Math.max(60, hero.offsetHeight - (header ? header.offsetHeight : 0));
    }
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      document.body.classList.toggle('fx-header-solid', window.scrollY > threshold);
      ticking = false;
    });
  }

  measure();
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { measure(); onScroll(); }, { passive: true });
  document.addEventListener('shopify:section:load', function () { measure(); onScroll(); });
})();
